import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import style from '@styles/account/AccountForm.module.scss'
import { Dropdown } from '@components/form/Dropdown'
import { TextField } from '@components/form/TextField'
import { UserType } from '@queries/types/user'
import { emptyUser } from '@lib/constants'

interface Props {
  user?: UserType
}

const AccountForm = ({ user = emptyUser }: Props) => {
  const { t } = useTranslation()
  const { register, errors, reset } = useFormContext()

  useEffect(() => {
    reset(user)
  }, [user, reset])

  const orgReachOptions = [
    ['', ''],
    ['100_or_less', t('account.form.100_or_less')],
    ['100_to_200', t('account.form.100_to_200')],
    ['200_to_500', t('account.form.200_to_500')],
    ['500_to_1000', t('account.form.500_to_1000')],
    ['under_5000', t('account.form.under_5000')],
    ['under_10_000', t('account.form.under_10_000')],
    ['over_10_000', t('account.form.over_10_000')],
    ['over_100_000', t('account.form.over_100_000')],
  ]

  const requiredErrorMessage = t('form.requiredErrorMessage')

  return (
    <>
      <div className={style.twoColumn}>
        <div className={style.twoColumnField}>
          <TextField
            label={t('account.form.firstName')}
            inputId="first_name"
            placeholder={t('account.form.firstNamePlaceholder')}
            error={errors.first_name}
            errorMessages={{ required: requiredErrorMessage }}
            ref={register({ required: true })}
          />
        </div>
        <div className={style.twoColumnField}>
          <TextField
            label={t('account.form.lastName')}
            inputId="last_name"
            placeholder={t('account.form.lastNamePlaceholder')}
            error={errors.last_name}
            errorMessages={{ required: requiredErrorMessage }}
            ref={register({ required: true })}
          />
        </div>
      </div>
      <TextField
        label={t('account.form.orgName')}
        inputId="organization_name"
        placeholder={t('account.form.orgNamePlaceholder')}
        error={errors.organization_name}
        errorMessages={{ required: requiredErrorMessage }}
        ref={register({ required: true })}
      />
      <Dropdown
        label={t('account.form.orgReach')}
        inputId="organization_reach"
        options={orgReachOptions}
        ref={register}
      />
      <TextField
        label={t('account.form.role')}
        inputId="role"
        placeholder={t('account.form.rolePlaceholder')}
        ref={register}
      />
      <TextField
        label={`${t('form.email')}*`}
        inputId="email"
        placeholder="email@email.com"
        error={errors.email}
        errorMessages={{ required: requiredErrorMessage }}
        ref={register({ required: true })}
      />
    </>
  )
}

export { AccountForm }
